import request from './index';

const EMS_PREFIX = '/route/order/web/ems';

/**
 * 获取EMS实时数据（首页总览）
 * @param {string} code - 基站编码，如 11010100001
 */
export const getEmsRealtimeData = code => {
  return request({
    url: `${EMS_PREFIX}/realtime/ems`,
    data: { code },
  });
};

/**
 * 获取PCS实时数据
 * @param {string} code - 基站编码
 * @param {number} no - PCS编号
 */
export const getPcsRealtimeData = (code, no) => {
  return request({
    url: `${EMS_PREFIX}/realtime/pcs`,
    data: { code, no },
  });
};

/**
 * 获取BMS实时数据
 * @param {string} code - 基站编码
 * @param {number} no - BMS编号
 */
export const getBmsRealtimeData = (code, no) => {
  return request({
    url: `${EMS_PREFIX}/realtime/bms`,
    data: { code, no },
  });
};

/**
 * 查询EMS历史数据
 * @param {Object} data - 查询参数
 * @param {string} data.proc - 过程名：bms_m_chart / pcs_m_chart / fz_m_chart / profit_1h / profit_1d / profit_mn
 * @param {string[]} data.param - 参数数组 [站点编码, 开始时间, 结束时间]
 */
export const queryEmsHistory = data => {
  return request({
    url: `${EMS_PREFIX}/history/query`,
    data,
  });
};
